import { Link } from "react-router-dom"
import { HugeiconsIcon } from "@/components/icons"
import { cn } from "@/lib/utils"
import { useIntl } from "react-intl"
import type { NavItem } from "../nav-config"
import {
  CONTAINER_ICON_WIDTH,
  CONTAINER_ICON_HEIGHT,
  ICON_SIZE,
  ACTIVE_GRADIENT,
} from "./dock-config"

export interface DockItemProps {
  item: NavItem
  index: number
  scale: number
  position: number
  isActive: boolean
  onClick: (path: string, index: number) => void
  iconRef: (el: HTMLDivElement | null) => void
}

export function DockItem({
  item,
  index,
  scale,
  position,
  isActive,
  onClick,
  iconRef,
}: DockItemProps) {
  const intl = useIntl()
  const scaledWidth = CONTAINER_ICON_WIDTH * scale
  const scaledHeight = CONTAINER_ICON_HEIGHT * scale

  return (
    <div
      ref={iconRef}
      className="absolute flex cursor-pointer flex-col items-center justify-end"
      style={{
        left: `${position - scaledWidth / 2}px`,
        bottom: 0,
        width: `${scaledWidth}px`,
        height: `${scaledHeight}px`,
        transformOrigin: "bottom center",
        zIndex: Math.round(scale * 10),
      }}
      onClick={() => onClick(item.path, index)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          onClick(item.path, index)
        }
      }}
      role="button"
      tabIndex={0}
      title={intl.formatMessage({ id: item.labelKey })}
      aria-label={intl.formatMessage({ id: item.labelKey })}
      aria-current={isActive ? "page" : undefined}
    >
      <Link
        to={item.path}
        className={cn(
          "flex size-full items-center justify-center rounded-full transition-colors duration-200"
        )}
        style={isActive ? { background: ACTIVE_GRADIENT } : undefined}
        aria-hidden
        tabIndex={-1}
        onClick={(e) => e.preventDefault()}
      >
        <HugeiconsIcon
          icon={item.icon}
          className={cn(
            "shrink-0 transition-colors duration-200",
            isActive ? "text-white" : "text-primary-text"
          )}
          size={ICON_SIZE}
        />
      </Link>
    </div>
  )
}
